import React, { Component } from 'react';

class SearchableList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            text: '',
            options: props.options
        }
        this.applyFormula = this.applyFormula.bind(this);
    }
    applyFormula(text) {
        return this.props.formula(text);
    }
    componentWillReceiveProps(newProps) {
        if (newProps.options !== this.state.options) {
            this.setState({ options: newProps.options });
        }
    }
    render() {
        const formula = this.applyFormula(this.state.text);
        const results = this.state.options.filter(formula);
        return (
            <div className="form-group">
                {!this.props.hideTitle &&
                    <label className="col-form-label">Members</label>
                }
                <input
                    onChange={(event) => {
                        this.setState({ text: event.target.value });
                    }}
                    type="text"
                    placeholder="Search members"
                    className="form-control m-b-20" />
                <div className="searchable-list nicescroll">
                    {results.length === 0 &&
                        <span className="searchable-list-item">{this.props.empty_message}</span>
                    }
                    {results.map((member, index) => {
                        const classMember = member.accepted ? 'text-info' : 'text-muted';
                        return (
                            <span className={"searchable-list-item " + classMember}>{member.email}</span>
                        )
                    })}
                </div>
            </div>
        )
    }
}

SearchableList.defaultProps = {
    formula(text) { return (x) => true },
    options: []
}

export default SearchableList;


// WEBPACK FOOTER //
// ./src/components/SearchableList.js